export default __webpack_public_path__ + "static/infra_1-1715e380315c6d3e9ade83f613917055.jpeg";